import { AgentTaskStatus } from '~/protos/agents'
import { useTaskObj } from './useTaskObj'
import useAdminConversation from '../super-admin/useAdminConversation'
import { verifyUUID } from '~/utils/utils'

export function useTaskDoc(index?: number, uuid?: string) {
  if (!!uuid && !verifyUUID(uuid)) {
    uuid = undefined // if uuid is not valid, then just return ""
  }
  let taskObj = useTaskObj(uuid ?? null)
  const conversation = useAdminConversation({ uuid: uuid ?? null })
  if (!taskObj && conversation && !!uuid) taskObj = conversation.task

  let documentGenerated
  let seneraiosGenerated

  if (index) {
    documentGenerated = taskObj?.details.orderedStateResponses[index]
    seneraiosGenerated = taskObj?.details.orderedStateResponses[index]
  } else {
    documentGenerated = taskObj?.details.orderedStateResponses.findLast(response => {
      return response.taskStatus === AgentTaskStatus.DOCUMENT_GENERATED
    })
    seneraiosGenerated = taskObj?.details.orderedStateResponses.findLast(response => {
      return response.taskStatus === AgentTaskStatus.MUNIT_SCENARIO_GENERATED
    })
  }

  const document = documentGenerated?.response?.[0]?.responseContentStream?.document
  const migrationDoc = documentGenerated?.response?.[0]?.responseContentStream?.migrationDocOutput

  if (document?.addFlowCode) {
    return document?.addFlowCode
  }
  if (migrationDoc) {
    return migrationDoc?.docMd ?? ''
  }
  if (documentGenerated) {
    for (const [key, value] of Object.entries(document!)) {
      if (value == null || value == null || value === '' || key === 'mappingSheetCsv') {
        continue
      }
      return value
    }
  }
  if (seneraiosGenerated) {
    return seneraiosGenerated.response?.[0].responseContentStream?.munitScenarios?.mdText!
  }
  return ''
}
